import { css } from '@emotion/core'
import styled from '@emotion/styled'
import { fontSize } from '@css/styles'
import { FontNormal } from '@css/fonts'
import { MQ } from '@css/constants'

export const ProductSelectPopupWrapper = styled('div')(css`
  padding: 0 47px;

  ${MQ.SMALL_SCREENS} {
    padding: 0;
  }
`)

export const Title = styled('div')(css`
  ${FontNormal(600)};
  ${fontSize(24)};
`)

export const Subtitle = styled('div')(css`
  ${fontSize(16)};
  ${FontNormal(400)};
  margin-top: 7px;
`)

export const QuestionLabel = styled('label')(css`
  ${FontNormal(600)};
  ${fontSize(14)};
  margin-top: 25px;
  margin-bottom: 3px;
  text-align: left;
  display: inline-block;
  width: 100%;
`)

export const Controls = styled('div')(css`
  max-width: 275px;
  margin: 0 auto;
`)

export const Footer = styled('div')(css`
  ${FontNormal(400)};
  ${fontSize(16)};
  font-style: italic;
  margin-top: 30px;
`)

export const btnStyles = css`
  width: 100%;
  margin-top: 24px;
`
